<div style="min-height: 500px">

  <h3 class="float-left" *ngIf="!novoPapel">Papeis
    <button class="btn btn-blue  ml-2" (click)="criarPapel()"><i class="k-icon k-i-add"></i> Novo</button>
  </h3>


  <ng-container *ngIf="novoPapel">
    <div class="card card-body">
      <form [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
            novalidate #frm="ngForm" (ngSubmit)="onSubmit()">
        <div class="form-group mb-3">
          <label for="nome">Nome</label>
          <input type="text" class="form-control" autocomplete="off"
                 id="nome" name="nome" [(ngModel)]="novoPapel.nome" #nome="ngModel"

                 placeholder="Nome do papel" value="" required appAutoFocus [autoFocus]="true">
          <div class="invalid-feedback">
            <p *ngIf="nome.errors?.required">Nome é obrigatório</p>
          </div>
        </div>


        <div  >
          <button type="submit" class="btn btn-primary waves-effect waves-light" [disabled]="salvando"  >Salvar
            <i class="k-icon k-i-loading ml-1" *ngIf="salvando"> </i>
          </button>
          <button type="button" class="btn btn-light waves-effect" data-dismiss="modal"
                  (click)="cancelarNovoPapel()">Fechar</button>
        </div>


      </form>
    </div>

  </ng-container>



  <div class="clearfix"></div>


  <i class="k-i-loading k-icon fa-2x mt-2 mb-2 centralizado " *ngIf="carregando"></i>

  <div *ngFor="let papel of papeis" class="mt-1">

    <kendo-grid
      [kendoGridBinding]="papel.operacoes"
      [loading]="carregando"  footerStyle="font-size: 11px;">
      <ng-template kendoGridToolbarTemplate [position]="'top'">
        <h4 class="text-center text-blue">
          Cod: {{papel.id }} - {{papel.nome}}
         <span class="badge badge-primary ml-1" *ngIf="papel.novo">novo</span>
        </h4>
      </ng-template>
      <kendo-grid-messages
        pagerPage="Página"
        pagerOf="de"
        pagerItems="itens"
        noRecords="Nenhuma operação vinculada ao papel "
        loading="Carregando"
        pagerItemsPerPage="ítems por página"
      >
      </kendo-grid-messages>

      <kendo-grid-column    [width]="50"  >
        <ng-template kendoGridCellTemplate   let-operacao >
          {{operacao.id}}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Operação"   [width]="200">
        <ng-template kendoGridCellTemplate let-operacao  >
          <span class=""   ><b>{{operacao.nome}}</b></span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Descrição">
        <ng-template kendoGridCellTemplate let-operacao   >
          <span class="pb-0 mb-0  text-black-50"> {{operacao.descricao }}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-command-column title="" [width]="100">
        <ng-template kendoGridCellTemplate let-isNew="isNew" let-operacao>

          <kendo-switch [(ngModel)]="operacao.ativa" (ngModelChange)="alterouOperacao(papel, operacao)"
                        [onLabel]="'Sim'"
                        [offLabel]="'Não'"></kendo-switch>
        </ng-template>
      </kendo-grid-command-column>

    </kendo-grid>

  </div>

</div>
